<template>
  <div>
    <v-progress-linear v-if="loading" :data-cy="dataCyFormField" color="primary" indeterminate />
    <div v-else class="height-4px" />
  </div>
</template>

<script setup>
defineProps({
  loading: { type: Boolean, required: true },
  dataCyFormField: { type: String, default: '' }
})
</script>
